module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1dRfMD/tc-custom/9781596439597.jpg?1737767945672",
      "alt": "This image is the cover for the book The Emperor's Ostrich"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Emperor's Ostrich\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Magic and mayhem abound in this fantasy adventure from the author of "), _c('i', [_vm._v("The Scandalous Sisterhood of Prickwillow Place")]), _vm._v(".")]), _c('br'), _c('br'), _vm._v("Young dairymaid Begonia has lost her cow Alfalfa. So she has set off on a search across the countryside even though she has nothing but a magical map to guide her. Along the way she meets a mother and baby, a woodcutter, a very dirty young man, and an eight-foot ostrich. "), _c('br'), _c('br'), _vm._v("Meanwhile, the emperor has gone missing from the royal palace in a most mysterious manner. Was it murder? Was it magic? It will take all of Begonia's wits to save the empire and get Alfalfa home safely.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Julie Berry\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Roaring Brook Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0